<script setup lang="ts">
import { Clock } from '@element-plus/icons-vue'
import { useIntervalFn } from '@vueuse/core'
import { DateTime } from 'luxon'
import { ref } from 'vue'

const props = defineProps<{ timezone: string }>()
const time = ref<string>('00:00:00 ZZZ')

useIntervalFn(() => {
  const now = DateTime.now().setZone(props.timezone)
  time.value = now.toFormat('HH:mm:ss ZZZZ')
})
</script>

<template>
  <div class="w-42 font-mono">
    <el-input input-style="text-align: center" :value="time" :readonly="true" :prefix-icon="Clock" disabled />
  </div>
</template>
